/*
 * @Description: 文件内容
 * @Author: 陈威达
 * @Date: 2022-11-01 11:08:33
 * @LastEditors: 陈威达
 * @LastEditTime: 2022-11-01 11:08:58
 */
const sm2 = require('sm-crypto').sm2
const publicKey2 = '048606042b3ba7de409fa4780115acf2f5694fee1c8ffa533f78de0207ca9a9f4688c744b22c06a3254f91fcc368faa3d88391e3f6f5da32f0472d495e4abcbd12'
// 1 - C1C3C2；	0 - C1C2C3；	默认为1
const cipherMode = 1
// 加密
function doEncrypt(msgString) {
  let msg = msgString
  if (typeof msgString !== 'string') {
    msg = JSON.stringify(msgString)
  }

  // 加密结果
  const encryptData = sm2.doEncrypt(msg, publicKey2, cipherMode)
  // 加密后的密文前需要添加04，后端才能正常解密
  const encrypt = '04' + encryptData
  return encrypt
}

export {
  doEncrypt
}

